(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Acquire", [], factory);
	else if(typeof exports === 'object')
		exports["Acquire"] = factory();
	else
		root["Acquire"] = factory();
})(this, function() {
return 